import script from "./VehicleCreateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleCreateModal.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleCreateModal.vue?vue&type=style&index=0&id=61a671c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a671c2"]])

export default __exports__